import { Callback, VoidCallback } from '@deqo/foundation';
import { EventSink, ModelMutateCallback, ModelMutation, ModelOperation, ModelView } from '@deqo/podopolis';
import { EditorPodSession } from '../../app/canvas/EditorPodSession';
import { ObjectManagerBackend, ObjectManagerBackendStreams } from '../../concepts/objects/ObjectManagerBackend';

export class EditorPodObjectManagerBackend implements ObjectManagerBackend {

    private idCounter = 1;
    private sessionId = null as string;

    constructor(
        public readonly namespace: string,
        private readonly pod: EditorPodSession,
        private createPolicy: Callback<boolean>) {
    }

    public generateId(): string {
        const sessionId = this.sessionId ?? (this.sessionId = this.pod.getThisClientProfileValue('sessionId'));
        return `${sessionId}/${this.idCounter++}`;
    }

    public getModel(): ModelView {
        return this.pod.getModel();
    }

    public getMutation(): ModelMutation {
        return this.pod.getMutation();
    }

    public mutate(impl: ModelMutateCallback): void {
        this.pod.mutate(impl);
    }

    public on(type: '*', to: EventSink<Iterable<string> | ModelOperation, string>): VoidCallback;
    public on<K extends keyof ObjectManagerBackendStreams>(type: K, to: EventSink<ObjectManagerBackendStreams[K], K>): VoidCallback;
    public on(type: any, to: any): VoidCallback {
        return this.pod.on(type, to);
    }

    public shouldAllowCreates(): boolean {
        return this.createPolicy();
    }

    public shouldAutoAllocate(): boolean {
        return false;
    }
}
